(function () {
  'use strict';

  function parseConfig(section) {
    var node = section.querySelector('[data-models-json]');
    if (!node) return { models: [] };
    try { return JSON.parse(node.textContent || '{}'); } catch (error) { return { models: [] }; }
  }

  function digits(value, limit) {
    return String(value || '').replace(/\D/g, '').slice(0, limit || 99);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function formatCpf(value) {
    var number = digits(value, 11);
    if (number.length <= 3) return number;
    if (number.length <= 6) return number.slice(0, 3) + '.' + number.slice(3);
    if (number.length <= 9) return number.slice(0, 3) + '.' + number.slice(3, 6) + '.' + number.slice(6);
    return number.slice(0, 3) + '.' + number.slice(3, 6) + '.' + number.slice(6, 9) + '-' + number.slice(9);
  }

  function validCpf(value) {
    var number = digits(value, 11);
    if (number.length !== 11 || /^(\d)\1{10}$/.test(number)) return false;
    function check(length) {
      var sum = 0;
      for (var index = 0; index < length; index += 1) sum += Number(number[index]) * (length + 1 - index);
      var result = (sum * 10) % 11;
      return (result === 10 ? 0 : result) === Number(number[length]);
    }
    return check(9) && check(10);
  }

  function formatCep(value) {
    var number = digits(value, 8);
    return number.length > 5 ? number.slice(0, 5) + '-' + number.slice(5) : number;
  }

  function formatCard(value) {
    return digits(value, 19).replace(/(.{4})/g, '$1 ').trim();
  }

  function chassisKey(value) {
    return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function knownModel(value, fallback) {
    var normalized = String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (normalized.indexOf('cruiser mini') !== -1) return 'Cruiser Mini';
    if (normalized.indexOf('cruiser s+') !== -1 || normalized.indexOf('cruiser s plus') !== -1) return 'Cruiser S+';
    if (normalized.indexOf('cruiser x') !== -1) return 'Cruiser X';
    if (normalized.indexOf('cruiser +') !== -1 || normalized.indexOf('cruiser plus') !== -1) return 'Cruiser +';
    if (normalized.indexOf('cruiser') !== -1) return 'Cruiser';
    if (normalized.indexOf('city') !== -1) return 'City';
    if (normalized.indexOf('l+') !== -1 || normalized.indexOf('l plus') !== -1) return 'E-bike L+';
    if (/\be[- ]?bike\s*l\b/.test(normalized)) return 'E-bike L';
    if (/\be[- ]?bike\s*d\b/.test(normalized)) return 'E-bike D';
    if (/\be[- ]?bike\s*s\b/.test(normalized)) return 'E-bike S';
    if (normalized.indexOf('e-bike') !== -1 || normalized.indexOf('ebike') !== -1) return 'E-bike';
    return fallback;
  }

  function apiError(payload, fallback) {
    if (payload && typeof payload.error === 'string' && payload.error) return payload.error;
    if (payload && typeof payload.message === 'string' && payload.message) return payload.message;
    if (payload && payload.details && typeof payload.details.message === 'string') return payload.details.message;
    return fallback;
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.random() * 16 | 0;
      return (character === 'x' ? random : (random & 3 | 8)).toString(16);
    });
  }

  function initialize(section) {
    if (!section || section.dataset.levPrimeReady === 'true') return;
    section.dataset.levPrimeReady = 'true';
    var config = parseConfig(section);
    var landing = section.querySelector('[data-prime-landing]');
    var checkout = section.querySelector('[data-prime-checkout]');
    var content = section.querySelector('[data-checkout-content]');
    var backButton = section.querySelector('[data-checkout-back]');
    var modelButtons = Array.prototype.slice.call(section.querySelectorAll('[data-model]'));
    var modelLabel = section.querySelector('[data-selected-model]');
    var monthly = section.querySelector('[data-monthly]');
    var installments = section.querySelector('[data-installments]');
    var cashPrice = section.querySelector('[data-cash-price]');
    var status = section.querySelector('[data-cart-status]');
    var stages = ['cpf', 'bike', 'plan', 'age', 'payment', 'address', 'review', 'success'];
    var state = {
      stage: 'browse', selectedModel: '', selectedPlan: 'semestral', cpf: '', bikes: [], bike: null, adult: null, customer: {}, payment: {}, billing: {}, cardToken: '', cardLastFour: '', buyerUuid: '', receiptId: '', error: '', loading: false, termsAccepted: false, transferPrompt: false, idempotencyKey: uuid()
    };

    function selectedPricing() {
      return (config.models || []).find(function (item) { return item.model === state.selectedModel; }) || config.models[0] || {};
    }

    function apiUrl(path) {
      var base = String(config.apiBaseUrl || '').replace(/\/$/, '');
      if (!base && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname)) {
        base = 'http://localhost:3000/levprime/vistoria';
      }
      if (!base) throw new Error('O checkout Lev Prime ainda não está conectado ao serviço de cadastro.');
      return base + (String(path || '').charAt(0) === '/' ? path : '/' + path);
    }

    function request(path, options) {
      return fetch(apiUrl(path), Object.assign({ credentials: 'include', headers: { Accept: 'application/json' } }, options || {})).then(async function (response) {
        var payload = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(apiError(payload, 'Não foi possível continuar. Tente novamente.'));
        return payload;
      });
    }

    function post(path, body, extraHeaders) {
      return request(path, { method: 'POST', headers: Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, extraHeaders || {}), body: JSON.stringify(body) });
    }

    function selectModel(modelName) {
      var model = (config.models || []).find(function (item) { return item.model === modelName; });
      if (!model) return;
      state.selectedModel = model.model;
      modelButtons.forEach(function (button) {
        var selected = button.dataset.model === modelName;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (modelLabel) modelLabel.textContent = model.model;
      if (monthly) monthly.textContent = String(model.monthly || '').replace('/mês', '');
      if (installments) installments.textContent = model.installments || '';
      if (cashPrice) cashPrice.textContent = model.cashPrice || '';
      if (status) status.textContent = 'Você confirmará o CPF e a bicicleta antes de informar o pagamento.';
    }

    function normalizeBike(row, index) {
      var chassis = String(row.chassisSerial || row.chassi || row.serialNumber || '').trim();
      var rawModel = String(row.bikeModel || row.model || row.name || row.product || state.selectedModel).trim();
      var model = knownModel(rawModel, state.selectedModel);
      return { key: chassis || String(row.motorSerial || row.engine || row.motor || index), label: String(row.product || row.name || model || 'Bike Lev').trim(), model: model || state.selectedModel, color: String(row.color || row.cor || '').trim(), chassis: chassis, motor: String(row.motorSerial || row.bikeMotor || row.engine || row.motor || '').trim(), eligible: row.eligible !== false && row.primeRegistered !== true && row.beforeMinimumPurchaseDate !== true, reason: String(row.eligibilityMessage || row.reason || '').trim() };
    }

    function summary() {
      var pricing = selectedPricing();
      var bike = state.bike || {};
      return '<aside class="lev-prime-checkout__summary"><div class="lev-prime-checkout__bike-icon" aria-hidden="true"></div><div><span>Lev Prime</span><strong>' + escapeHtml(state.selectedModel) + '</strong></div><dl><div><dt>Cor</dt><dd>' + escapeHtml(bike.color || '—') + '</dd></div><div><dt>Chassi</dt><dd>' + escapeHtml(bike.chassis || '—') + '</dd></div><div><dt>Motor</dt><dd>' + escapeHtml(bike.motor || '—') + '</dd></div></dl><div class="lev-prime-checkout__plan-summary"><strong>Plano Semestral</strong><span>Duração de 6 meses.</span><b>6x de ' + escapeHtml(String(pricing.monthly || '').replace('/mês', '')) + '</b><i aria-hidden="true">✓</i></div><ul><li>6 parcelas sem juros no cartão</li><li>Valor integral do semestre parcelado em 6x</li><li>Renovação automática a cada 6 meses</li></ul></aside>';
    }

    function errorBox() {
      return state.error ? '<p class="lev-prime-checkout__error" role="alert">' + escapeHtml(state.error) + '</p>' : '';
    }

    function actionButton(label, action, disabled) {
      return '<button class="lev-prime-checkout__primary" type="button" data-action="' + action + '"' + (disabled ? ' disabled' : '') + '>' + label + (state.loading ? '' : '<span aria-hidden="true">›</span>') + '</button>';
    }

    function cardLayout(main, action) {
      return '<div class="lev-prime-checkout__top">' + summary() + '<div class="lev-prime-checkout__divider" aria-hidden="true"></div><div class="lev-prime-checkout__main">' + main + errorBox() + '</div></div><div class="lev-prime-checkout__bottom">' + action + '</div>';
    }

    function renderCpf() {
      return cardLayout('<h2>Informe o CPF do proprietário da Lev a ser assegurada</h2><label for="levprime-cpf">CPF</label><input id="levprime-cpf" data-field="cpf" inputmode="numeric" autocomplete="off" placeholder="000.000.000-00" value="' + escapeHtml(formatCpf(state.cpf)) + '"' + (state.loading ? ' disabled' : '') + '>' + (state.loading ? '<p class="lev-prime-checkout__loading">Buscando suas bikes...</p>' : ''), actionButton(state.loading ? 'Buscando...' : 'Próximo', 'cpf-next', state.loading));
    }

    function renderBike() {
      var options = state.bikes.map(function (bike) {
        var picked = state.bike && state.bike.key === bike.key;
        return '<button class="lev-prime-checkout__bike-option' + (picked ? ' is-selected' : '') + '" type="button" data-action="pick-bike" data-bike-key="' + escapeHtml(bike.key) + '"' + (!bike.eligible ? ' disabled' : '') + '><span class="lev-prime-checkout__radio" aria-hidden="true"></span><span><strong>' + escapeHtml(bike.label) + '</strong><small>' + escapeHtml([bike.color, bike.chassis ? 'Chassi ' + bike.chassis : '', bike.motor ? 'Motor ' + bike.motor : ''].filter(Boolean).join(' · ')) + '</small>' + (!bike.eligible ? '<em>' + escapeHtml(bike.reason || 'Esta bike não está elegível para o Lev Prime.') + '</em>' : '') + '</span></button>';
      }).join('');
      return cardLayout('<h2>Selecione a Lev que deseja proteger</h2><p class="lev-prime-checkout__muted">CPF do proprietário: ' + escapeHtml(formatCpf(state.cpf)) + '</p><div class="lev-prime-checkout__bike-list">' + options + '</div><button class="lev-prime-checkout__link" type="button" data-action="change-cpf">Alterar CPF</button>', actionButton('Próximo', 'bike-next', !state.bike));
    }

    function renderPlan() {
      var pricing = selectedPricing();
      return cardLayout('<h2>Escolha a modalidade</h2><button class="lev-prime-checkout__plan-option is-selected" type="button" aria-pressed="true"><span class="lev-prime-checkout__radio" aria-hidden="true"></span><span><strong>Plano Semestral</strong><small>Duração de 6 meses.</small><b>6x de ' + escapeHtml(String(pricing.monthly || '').replace('/mês', '')) + ' <em>sem juros</em></b></span></button>', actionButton('Próximo', 'plan-next', false));
    }

    function renderAge() {
      return cardLayout('<h2>O Proprietário é maior de idade?</h2><div class="lev-prime-checkout__age"><button type="button" data-action="adult" data-value="yes" class="' + (state.adult === true ? 'is-selected' : '') + '"><span class="lev-prime-checkout__radio"></span>Sim</button><button type="button" data-action="adult" data-value="no" class="' + (state.adult === false ? 'is-selected' : '') + '"><span class="lev-prime-checkout__radio"></span>Não</button></div>', actionButton(state.loading ? 'Carregando...' : 'Próximo', 'age-next', state.adult === null || state.loading));
    }

    function renderPayment() {
      var customer = state.customer;
      var payment = state.payment;
      return cardLayout('<h2>Preencha os dados de pagamento</h2><form id="levprime-payment-form" class="lev-prime-checkout__form"><label>Número do cartão<input data-field="cardNumber" inputmode="numeric" autocomplete="cc-number" value="' + escapeHtml(formatCard(payment.cardNumber)) + '"></label><label>Nome como consta no cartão<input data-field="cardholderName" autocomplete="cc-name" value="' + escapeHtml(payment.cardholderName || '') + '"></label><label>E-mail do titular<input data-field="email" type="email" autocomplete="email" value="' + escapeHtml(payment.email || customer.email || '') + '"></label><div class="lev-prime-checkout__form-row"><label>CVV<input data-field="cardCvv" inputmode="numeric" autocomplete="cc-csc" maxlength="4" value="' + escapeHtml(payment.cardCvv || '') + '"></label><label>Mês<input data-field="cardExpMonth" inputmode="numeric" autocomplete="cc-exp-month" maxlength="2" placeholder="MM" value="' + escapeHtml(payment.cardExpMonth || '') + '"></label><label>Ano<input data-field="cardExpYear" inputmode="numeric" autocomplete="cc-exp-year" maxlength="4" placeholder="AAAA" value="' + escapeHtml(payment.cardExpYear || '') + '"></label></div></form><p class="lev-prime-checkout__security">O número do cartão é tokenizado pela Barte neste navegador e não é gravado pela Lev.</p>', actionButton(state.loading ? 'Salvando cartão...' : 'Próximo', 'payment-next', state.loading));
    }

    function addressPreview() {
      var billing = state.billing;
      return [billing.street, billing.neighborhood, billing.city, billing.state].filter(Boolean).join('\n');
    }

    function renderAddress() {
      var billing = state.billing;
      var found = billing.street && billing.city && billing.state;
      return cardLayout('<h2>Informe o endereço de cobrança do cartão</h2><form id="levprime-address-form" class="lev-prime-checkout__form"><label>CEP<input data-field="cep" inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="00000-000" value="' + escapeHtml(formatCep(billing.cep)) + '"></label>' + (found ? '<div class="lev-prime-checkout__address-preview">' + escapeHtml(addressPreview()).replace(/\n/g, '<br>') + '</div><label>Número<input data-field="number" inputmode="numeric" autocomplete="address-line2" value="' + escapeHtml(billing.number || '') + '"></label><label>Complemento<input data-field="complement" autocomplete="address-line3" placeholder="Ex: Apto 000" value="' + escapeHtml(billing.complement || '') + '"></label>' : '') + '</form>', actionButton('Revisar Dados', 'address-next', state.loading));
    }

    function renderReview() {
      var customer = state.customer;
      var payment = state.payment;
      var billing = state.billing;
      var privacy = config.privacyUrl ? '<a href="' + escapeHtml(config.privacyUrl) + '" target="_blank" rel="noopener">política de privacidade</a>' : 'política de privacidade';
      return cardLayout('<h2>Revise os dados e finalize a compra</h2><div class="lev-prime-checkout__review"><div><span>Nome Completo do Segurado</span><strong>' + escapeHtml([customer.firstName, customer.lastName].filter(Boolean).join(' ') || payment.cardholderName) + '</strong><span>CPF do Proprietário</span><strong>' + escapeHtml(formatCpf(state.cpf)) + '</strong><span>Celular</span><strong>' + escapeHtml(customer.phoneDigits || '—') + '</strong><span>E-mail</span><strong>' + escapeHtml(customer.email || payment.email || '—') + '</strong></div><div><span>Nome Completo do Pagador</span><strong>' + escapeHtml(payment.cardholderName) + '</strong><span>Cartão</span><strong>•••• ' + escapeHtml(state.cardLastFour || digits(payment.cardNumber).slice(-4)) + '</strong><span>Endereço de cobrança</span><strong>' + escapeHtml([billing.street, billing.number, billing.city, billing.state].filter(Boolean).join(', ')) + '</strong></div></div><label class="lev-prime-checkout__terms"><input type="checkbox" data-field="terms"' + (state.termsAccepted ? ' checked' : '') + '><span>Li e aceito os termos e condições do Lev Prime e a ' + privacy + '.</span></label><p class="lev-prime-checkout__security">Ao confirmar, o cartão será tokenizado e somente o token e os quatro últimos dígitos poderão ser persistidos.</p>', actionButton(state.loading ? 'Confirmando...' : 'Confirmar assinatura', 'confirm', !state.termsAccepted || state.loading));
    }

    function renderSuccess() {
      return cardLayout('<h2>Pedido em Processamento</h2><div class="lev-prime-checkout__success"><strong>Em algumas horas seu pagamento será concluído.</strong><p>Agora só falta você ativar seu plano.</p><p>Após a confirmação do pedido, acesse seu e-mail ou WhatsApp para dar início ao processo de ativação.</p>' + (state.receiptId ? '<small>Protocolo: ' + escapeHtml(state.receiptId) + '</small>' : '') + '</div>', '');
    }

    function render() {
      if (state.stage === 'browse') {
        landing.hidden = false;
        checkout.hidden = true;
        document.body.classList.remove('lev-prime-checkout-open');
        return;
      }
      landing.hidden = true;
      checkout.hidden = false;
      document.body.classList.add('lev-prime-checkout-open');
      backButton.hidden = state.stage === 'success';
      var renderers = { cpf: renderCpf, bike: renderBike, plan: renderPlan, age: renderAge, payment: renderPayment, address: renderAddress, review: renderReview, success: renderSuccess };
      content.innerHTML = renderers[state.stage]() + transferModal();
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }

    function transferDestination() {
      var chassis = state.bike && String(state.bike.chassis || '').trim();
      if (!chassis) return '/pages/bikes';
      return '/pages/transferencia-bike?chassi=' + encodeURIComponent(chassis);
    }

    function transferModal() {
      if (!state.transferPrompt) return '';
      return '<div class="lev-prime-checkout__transfer" role="dialog" aria-modal="true" aria-labelledby="levprime-transfer-title"><div class="lev-prime-checkout__transfer-panel"><p id="levprime-transfer-title">Somente maiores de 18 anos poderão ser proprietários-segurados pelo Lev Prime.</p><p>Caso o proprietário seja menor de idade será necessário realizar a transferência de titularidade para o maior de idade responsável que será o proprietário-segurado.</p><a class="lev-prime-checkout__primary" href="' + escapeHtml(transferDestination()) + '">Iniciar Transferência de Titularidade <span aria-hidden="true">›</span></a></div></div>';
    }

    function setStage(stage) {
      state.stage = stage;
      state.error = '';
      render();
    }

    function goBack() {
      if (state.loading) return;
      if (state.transferPrompt) { state.transferPrompt = false; render(); return; }
      var index = stages.indexOf(state.stage);
      if (index <= 0) setStage('browse');
      else setStage(stages[index - 1]);
    }

    async function loadBikes() {
      if (!validCpf(state.cpf)) { state.error = 'Informe um CPF válido com 11 dígitos.'; render(); return; }
      state.loading = true;
      state.error = '';
      render();
      try {
        var separator = String(config.bikesPath || '').indexOf('?') === -1 ? '?' : '&';
        var payload = await request(String(config.bikesPath || '') + separator + 'cpf=' + encodeURIComponent(state.cpf));
        var rows = Array.isArray(payload.bikes) ? payload.bikes : [];
        state.bikes = rows.map(normalizeBike);
        if (!state.bikes.length) throw new Error('Nenhuma Lev foi encontrada para este CPF. Verifique se ele é o mesmo da nota fiscal.');
        var chassisCandidates = state.bikes.map(function (bike) { return bike.chassis; }).filter(Boolean);
        if (chassisCandidates.length) {
          var checks = await Promise.all([
            post(config.registeredPath, { cpfDigits: state.cpf, chassisCandidates: chassisCandidates }).catch(function () { return {}; }),
            post(config.purchaseEligibilityPath, { chassisCandidates: chassisCandidates }).catch(function () { return {}; })
          ]);
          var registered = new Set((checks[0].registeredNormalized || []).map(chassisKey));
          var tooOld = new Set((checks[1].preMinPurchaseNormalized || []).map(chassisKey));
          state.bikes.forEach(function (bike) {
            if (registered.has(chassisKey(bike.chassis))) { bike.eligible = false; bike.reason = 'Esta bike já possui assinatura Lev Prime registrada.'; }
            if (tooOld.has(chassisKey(bike.chassis))) { bike.eligible = false; bike.reason = 'Bikes adquiridas antes de 01/01/2022 não são elegíveis.'; }
          });
        }
        var eligible = state.bikes.filter(function (bike) { return bike.eligible; });
        state.bike = eligible.length === 1 ? eligible[0] : null;
        state.stage = 'bike';
      } catch (error) {
        state.error = error.message || 'Não foi possível buscar suas bikes.';
      } finally {
        state.loading = false;
        render();
      }
    }

    async function loadCustomer() {
      if (state.adult === null) { state.error = 'Informe se o proprietário é maior de idade.'; render(); return; }
      state.loading = true;
      state.error = '';
      render();
      try {
        var bike = state.bike || {};
        await post('/api/levprime/proprietario-maior-idade', { cpf: state.cpf, maiorDeIdade: state.adult === true, bikeModel: bike.model || state.selectedModel, bikeCor: bike.color || '', bikeChassi: bike.chassis || '', bikeMotor: bike.motor || '', codemp: config.codemp || '0' });
        if (state.adult !== true) { state.transferPrompt = true; return; }
        state.stage = 'payment';
      } catch (error) {
        state.error = error.message || 'Não foi possível registrar se o proprietário é maior de idade.';
      } finally {
        state.loading = false;
        render();
      }
    }

    function validatePayment() {
      var payment = state.payment;
      var card = digits(payment.cardNumber, 19);
      var month = Number(digits(payment.cardExpMonth, 2));
      var yearDigits = digits(payment.cardExpYear, 4);
      if (card.length < 13) return 'Informe um número de cartão válido.';
      if (!String(payment.cardholderName || '').trim()) return 'Informe o nome como consta no cartão.';
      if (!/^\S+@\S+\.\S+$/.test(String(payment.email || ''))) return 'Informe um e-mail válido.';
      if (digits(payment.cardCvv, 4).length < 3) return 'Informe um CVV válido.';
      if (month < 1 || month > 12 || (yearDigits.length !== 2 && yearDigits.length !== 4)) return 'Informe uma validade válida.';
      return '';
    }

    async function lookupCep() {
      var cep = digits(state.billing.cep, 8);
      if (cep.length !== 8) return;
      state.loading = true;
      state.error = '';
      render();
      try {
        var response = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
        var payload = await response.json();
        if (!response.ok || payload.erro) throw new Error('CEP não encontrado.');
        state.billing.street = payload.logradouro || '';
        state.billing.neighborhood = payload.bairro || '';
        state.billing.city = payload.localidade || '';
        state.billing.state = payload.uf || '';
      } catch (error) {
        state.error = error.message || 'Não foi possível buscar o CEP.';
      } finally {
        state.loading = false;
        render();
      }
    }

    async function saveCard() {
      var paymentError = validatePayment();
      if (paymentError) { state.error = paymentError; render(); return; }
      state.loading = true;
      state.error = '';
      render();
      try {
        if (!window.LevPrimeBarte || typeof window.LevPrimeBarte.tokenize !== 'function') {
          throw new Error('O SDK da Barte não carregou. Atualize a página e tente novamente.');
        }
        var bike = state.bike || {};
        var buyerPayload = await post('/api/levprime/subscription-barte/create-buyer', { subscriptionType: 'semestral', bikeModel: bike.model || state.selectedModel, payerEmail: state.payment.email, cpfTitular: state.cpf, document: state.cpf, cardholderName: state.payment.cardholderName, bikeCor: bike.color || '', bikeChassi: bike.chassis || '', bikeMotor: bike.motor || '', codemp: config.codemp || '0' });
        state.buyerUuid = String((buyerPayload.buyer && buyerPayload.buyer.uuid) || buyerPayload.buyerUuid || '');
        if (!state.buyerUuid) throw new Error('A Barte não retornou o identificador do comprador.');
        var sdk = await request('/api/levprime/subscription-barte/sdk-access-token');
        var tokenized = await window.LevPrimeBarte.tokenize({ accessToken: sdk.accessToken, environment: sdk.environment || 'sandbox', buyerUuid: state.buyerUuid, cardholderName: state.payment.cardholderName, cardNumber: digits(state.payment.cardNumber, 19), cardCvv: digits(state.payment.cardCvv, 4), cardExpMonth: digits(state.payment.cardExpMonth, 2), cardExpYear: digits(state.payment.cardExpYear, 4) });
        state.cardToken = String(tokenized.cardToken || '');
        state.cardLastFour = String(tokenized.lastFourDigits || digits(state.payment.cardNumber).slice(-4));
        if (!state.cardToken) throw new Error('A Barte não retornou o token seguro do cartão.');
        await post('/api/levprime/subscription-barte/save-card', { buyerUuid: state.buyerUuid, cardToken: state.cardToken, cardLastFour: state.cardLastFour, cardBrand: tokenized.brand || '', cpf: state.cpf, payerEmail: state.payment.email, cardholderName: state.payment.cardholderName, bikeChassi: bike.chassis || '', bikeModel: bike.model || state.selectedModel, bikeCor: bike.color || '', bikeMotor: bike.motor || '' });
        state.payment.cardNumber = '';
        state.payment.cardCvv = '';
        state.payment.cardExpMonth = '';
        state.payment.cardExpYear = '';
        state.stage = 'address';
      } catch (error) {
        state.error = error.message || 'Não foi possível salvar o cartão.';
      } finally {
        state.loading = false;
        render();
      }
    }

    function checkoutPayload() {
      var bike = state.bike || {};
      var customer = state.customer;
      var payment = state.payment;
      var billing = state.billing;
      return { subscriptionType: 'semestral', bikeModel: bike.model || state.selectedModel, bikeLabel: bike.label, payerEmail: payment.email, cpfTitular: state.cpf, document: state.cpf, firstName: customer.firstName, lastName: customer.lastName, cardholderName: payment.cardholderName, phone: customer.phoneDigits, codemp: config.codemp || '0', bikeCor: bike.color, bikeChassi: bike.chassis, bikeMotor: bike.motor, billingCepDigits: digits(billing.cep, 8), billingStreet: billing.street, billingNumber: billing.number, billingNeighborhood: billing.neighborhood, billingCity: billing.city, billingState: billing.state, billingComplement: billing.complement };
    }

    async function finishCheckout() {
      if (!state.termsAccepted || state.loading) return;
      state.loading = true;
      state.error = '';
      render();
      try {
        var basePayload = checkoutPayload();
        if (!state.buyerUuid) {
          var buyerPayload = await post(config.buyerPath, basePayload, { 'Idempotency-Key': state.idempotencyKey + ':buyer' });
          state.buyerUuid = String((buyerPayload.buyer && buyerPayload.buyer.uuid) || buyerPayload.buyerUuid || buyerPayload.uuid || '');
          if (!state.buyerUuid) throw new Error('O serviço não retornou o identificador do comprador.');
        }
        if (!state.cardToken) throw new Error('Salve o cartão na etapa de pagamento antes de confirmar.');
        var result = await post(config.submitPath, Object.assign({}, basePayload, { barteBuyerUuid: state.buyerUuid, cardToken: state.cardToken, cardLastFour: state.cardLastFour }), { 'Idempotency-Key': state.idempotencyKey + ':registration' });
        if (result.success !== true) throw new Error(apiError(result, 'O cadastro não foi confirmado pelo serviço.'));
        state.receiptId = String(result.orderId || result.receiptId || result.id || '');
        state.stage = 'success';
      } catch (error) {
        state.error = error.message || 'Não foi possível concluir o cadastro. Confira os dados e tente novamente.';
      } finally {
        state.loading = false;
        render();
      }
    }

    function isLocalDevHost() {
      var host = String(window.location.hostname || '');
      var base = String(config.apiBaseUrl || '');
      return /^(localhost|127\.0\.0\.1)$/i.test(host) || /localhost|127\.0\.0\.1/i.test(base);
    }

    /** Dev: Ctrl+B then C (or Ctrl+C) — fill sandbox Barte card / billing address. */
    function fillDevCheckoutFields() {
      if (state.stage === 'payment') {
        state.cardToken = '';
        state.cardLastFour = '';
        state.payment = Object.assign({}, state.payment, {
          cardNumber: '5383638854440891',
          cardholderName: 'JOSE DAS NEVES TEST',
          email: state.payment.email || state.customer.email || 'jose.teste.levprime@example.com',
          cardCvv: '220',
          cardExpMonth: '12',
          cardExpYear: '2030'
        });
        state.error = '';
        render();
        return true;
      }
      if (state.stage === 'address') {
        state.billing = {
          cep: '20021130',
          street: 'Av. General Justo',
          number: '375',
          neighborhood: 'Centro',
          city: 'Rio de Janeiro',
          state: 'RJ',
          complement: 'Lev Prime Dev'
        };
        state.error = '';
        render();
        return true;
      }
      return false;
    }

    var expectingDevFill = false;
    var expectingDevFillTimer = null;
    window.addEventListener('keydown', function (event) {
      if (!isLocalDevHost()) return;
      if (checkout.hidden || state.stage === 'browse' || state.stage === 'success') return;
      if (
        event.ctrlKey &&
        (event.key === 'b' || event.key === 'B') &&
        !event.shiftKey &&
        !event.altKey &&
        !event.metaKey
      ) {
        event.preventDefault();
        expectingDevFill = true;
        if (expectingDevFillTimer) clearTimeout(expectingDevFillTimer);
        expectingDevFillTimer = setTimeout(function () { expectingDevFill = false; }, 1500);
        return;
      }
      if (!expectingDevFill) return;
      if (event.key === 'c' || event.key === 'C') {
        event.preventDefault();
        event.stopPropagation();
        expectingDevFill = false;
        if (expectingDevFillTimer) clearTimeout(expectingDevFillTimer);
        fillDevCheckoutFields();
      }
    }, true);

    modelButtons.forEach(function (button) { button.addEventListener('click', function () { selectModel(button.dataset.model || ''); }); });
    section.querySelectorAll('[data-scroll-selector]').forEach(function (button) {
      button.addEventListener('click', function () {
        var selector = section.querySelector('.lev-prime__selector');
        if (selector) selector.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
    section.querySelectorAll('[data-start-checkout]').forEach(function (button) { button.addEventListener('click', function () { setStage('cpf'); }); });
    backButton.addEventListener('click', goBack);

    content.addEventListener('input', function (event) {
      var field = event.target && event.target.dataset ? event.target.dataset.field : '';
      if (!field) return;
      if (field === 'cpf') { state.cpf = digits(event.target.value, 11); event.target.value = formatCpf(state.cpf); return; }
      if (field === 'terms') { state.termsAccepted = Boolean(event.target.checked); render(); return; }
      if (field === 'cep' || field === 'number' || field === 'complement') {
        state.billing[field] = field === 'cep' ? digits(event.target.value, 8) : event.target.value;
        if (field === 'cep') { event.target.value = formatCep(state.billing.cep); if (state.billing.cep.length === 8) lookupCep(); }
        return;
      }
      if (['cardNumber', 'cardCvv', 'cardExpMonth', 'cardExpYear'].indexOf(field) !== -1) {
        state.cardToken = '';
        state.cardLastFour = '';
        state.payment[field] = digits(event.target.value, field === 'cardNumber' ? 19 : field === 'cardCvv' ? 4 : field === 'cardExpYear' ? 4 : 2);
        event.target.value = field === 'cardNumber' ? formatCard(state.payment[field]) : state.payment[field];
        return;
      }
      state.payment[field] = event.target.value;
    });

    content.addEventListener('click', function (event) {
      var target = event.target.closest('[data-action]');
      if (!target || target.disabled) return;
      var action = target.dataset.action;
      if (action === 'cpf-next') loadBikes();
      if (action === 'change-cpf') setStage('cpf');
      if (action === 'pick-bike') { state.bike = state.bikes.find(function (bike) { return bike.key === target.dataset.bikeKey; }) || null; if (state.bike && (config.models || []).some(function (model) { return model.model === state.bike.model; })) selectModel(state.bike.model); render(); }
      if (action === 'bike-next') setStage('plan');
      if (action === 'plan-next') setStage('age');
      if (action === 'adult') { state.adult = target.dataset.value === 'yes'; state.error = ''; render(); }
      if (action === 'age-next') loadCustomer();
      if (action === 'payment-next') saveCard();
      if (action === 'address-next') { if (digits(state.billing.cep, 8).length !== 8 || !state.billing.street || !state.billing.city || !state.billing.state || !String(state.billing.number || '').trim()) { state.error = 'Informe um endereço de cobrança completo.'; render(); } else setStage('review'); }
      if (action === 'confirm') finishCheckout();
    });

    var initial = modelButtons.find(function (button) { return button.classList.contains('is-selected'); }) || modelButtons[0];
    if (initial) selectModel(initial.dataset.model || '');
    render();
  }

  function initializeAll(root) { (root || document).querySelectorAll('[data-lev-prime]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
